import { FavoritesAssignWidgetContainer } from '@cian/favorites-assign-widget';
import * as React from 'react';

import {
  trackCreateFolder,
  trackSaveToFolder,
  trackFolderNameClick,
  trackNotificationSaveToFolder,
  trackNotificationChangeFolder,
} from './tracking';
import { selectIsAuthenticated } from '../../selectors/isAuthenticated';
import { selectRecommendations } from '../../selectors/recommendations';
import { useAppDispatch, useAppSelector as useSelector } from '../../types';
import { requestAuthentication } from '../../thunks';
import { useApplicationContext } from '../../utils/applicationContext';

export const useFavoritesAssignWidget = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const recommendations = useSelector(selectRecommendations);

  const {
    custom: { isMobile },
  } = useApplicationContext();

  const handleLogin = React.useCallback(() => {
    dispatch(requestAuthentication({}));

    return false;
  }, [dispatch]);

  const handleSaveOffer = React.useCallback(
    (offerId: number) => {
      const analyticsData = recommendations.find(recommendation => recommendation.offerId === offerId)?.analyticsData;
      const position = analyticsData?.type === 'offer' ? analyticsData.products[0].position : 1;

      trackSaveToFolder(offerId, position);
    },
    [recommendations],
  );

  return React.useMemo(
    () => (
      <FavoritesAssignWidgetContainer
        isAuthenticated={isAuthenticated}
        disableNotification={!isMobile}
        onNotificationSaveToFolder={offerId => trackNotificationSaveToFolder({ offerId })}
        onNotificationChangeFolder={offerId => trackNotificationChangeFolder({ offerId })}
        onCreateFolder={trackCreateFolder}
        onSaveOffer={handleSaveOffer}
        onWaitForLogin={handleLogin}
        onClickFolderName={trackFolderNameClick}
      />
    ),
    [isAuthenticated, isMobile, handleLogin, handleSaveOffer],
  );
};
